import { ButtonGroup, Button, Box, useColorMode, useColorModeValue } from '@chakra-ui/react';

const ButtonSelector = ({ buttons, selected, onSelect, icon, w, m, h, variant, bg, isGeneralSelected }) => {
  const bgColor = useColorModeValue('white', '#0E1633');
  const inactiveTabColor = useColorModeValue('#262D47', '#9FABCB');
  const boxShadow = useColorModeValue('unset', '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <Box
      display="flex"
      alignItems="center"
      borderRadius="16px"
      background={bg ?? bgColor}
      padding="2px"
      top="24px"
      w={w}
      //mt="-2px"
      m={m ?? '-2px 0 0 0'}
    >
      <ButtonGroup w="100%">
        {buttons.map((button, index) => (
          <Box key={button.key} 
            position="relative" w="100%" m="0 !important" 
            pointerEvents={button.key === 'disabled' ? 'none !important' : ''}
            opacity={button.key === 'disabled' ? '0.2 !important' : '1'}
            >
            <Button
              variant={selected === button.key || isGeneralSelected === index ? (variant ? `button-${variant}${ isDark ? '-g' : ''}` : 'button-lg') : (variant ? `ghost-${variant}` : 'ghost-lg')}
              borderRadius="16px"
              fontWeight={selected === button.key || isGeneralSelected === index ? '600' : '400 !important'}
              color={selected === button.key || isGeneralSelected === index ? 'white' : inactiveTabColor}
              boxShadow={selected === button.key || isGeneralSelected === index ? boxShadow : ''}
              m="0px !important"
              w="100%"
              outline="unset"
              transition="0s all"
              _focus={{
                outline: 'unset !important'
              }}
              h={h ?? '52px'}
              onClick={() => onSelect(button.key)}
            >
              { button.name !== '' ? button.name 
                : (<button.icon color="white" fontSize="24px" m="5px 0 0 5px" />)
              }
            </Button>

            {index !== buttons.length - 1 && (
              <Box
                w="1px"
                h="12px"
                bg="rgba(255, 255, 255, 0.3)"
                opacity="0.3"
                position="absolute"
                top="50%"
                left="100%"
                transform="translate(-50%, -50%)"
                borderRadius="5px"
              />
            )}
          </Box>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default ButtonSelector;